import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    slide:
      'flex h-20 w-20 shrink-0 grow-0 opacity-50 duration-300 hover:opacity-100',
    thumb: 'cursor-pointer'
  },
  variants: {
    selected: {
      true: {
        slide: 'opacity-100'
      }
    }
  }
});
